module.exports = __webpack_public_path__ + "img/case-qrcode.d0772e77.png";